export const theme = {
  palette: {
    primary: {
      // Czerwień strony iSA (--isa-red). Biały tekst na niej ma kontrast 5,81:1 (WCAG AA);
      // wcześniejsze #F20B32 dawało 4,31:1, za mało dla zwykłego tekstu na przyciskach.
      main: '#CB092A',
    },
    secondary: {
      main: '#ae0193',
    },
    error: {
      // Błędy walidacji przy pytaniach. Domyślny czerwony MUI (#f44336) ma na białym 3,68:1 — za mało dla tekstu
      // (WCAG AA 4,5:1); czerwień strony #CB092A ma 5,81:1.
      main: '#CB092A',
    },
  },
  typography: {
    fontFamily: 'Poppins, sans-serif',
  },
}

export default theme